import { useLocation, useSearchParams } from 'react-router-dom'

import { HotelImage } from 'shared/api/tours/search'
import { AppAdviceText } from 'shared/ui/app-advice-text'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ImageGallery } from 'shared/ui/image-gallery'
import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

const RADIX_BASE = 10
const DEFAULT_SLIDE_INDEX = 0

const PreviewPage = () => {
  const [params] = useSearchParams()
  const previewIndex = params.get('index')
  const { hotelName, images } = useLocation().state as {
    hotelName: string
    images: HotelImage[]
  }

  if (!hotelName || !images) {
    return (
      <div className="container">
        <Loader marginTop={200} />
        <AppAdviceText />
      </div>
    )
  }

  return (
    <div>
      <HeaderGoBack
        variant={'grey'}
        buttonWhite
        title={hotelName}
      />
      <div className={s.content}>
        <ImageGallery
          initialSlideIndex={
            previewIndex
              ? parseInt(previewIndex, RADIX_BASE)
              : DEFAULT_SLIDE_INDEX
          }
          images={images.map((i) => i.src)}
        />
      </div>
    </div>
  )
}

export default PreviewPage
